module.exports = __webpack_public_path__ + "static/media/gender-women-primary.a24d6a0c.svg";